import React from "react";
import Layout from "../../components/layout";

const Timeclocksetup = () => {
  return <>Timeclocksetup</>;
};

export default Timeclocksetup;
